import axios from 'axios';
import { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import OutsideClickHandler from 'react-outside-click-handler';
import core from '../../core';
import useT from '../../i18n/useT';

const CreateContainer = ({show, setShow, formData, setFormData, submit, loading, type}) => {
    const t = useT();
    const [vinList, setVinList] = useState([]);
    const [showVinList, setShowVinList] = useState(false);
    const [filteredVinList, setFilteredVinList] = useState([]);
    const [boats, setBoats] = useState([]);

    useEffect(() => {
        axios('/api/vin-codes/booking?type=containers')
            .then((res) => {
                setVinList([...res.data.data]);
                setFilteredVinList([...res.data.data]);
            })
            .catch((err) => {
                
            })

        axios('/api/boats?limit=50&page=1&keyword=&asc=desc&status=us_port&sort_by=id')
            .then((res) => {
                setBoats([...res.data.data]);
            })
            .catch((err) => {
                
            })
    }, [])

    return(
        <Modal show={show} onHide={() => setShow(false)} size='xl' centered>
            <Modal.Header closeButton><h3>{type === "edit" ? t("containers.editTitle") : t("containers.addTitle")}</h3></Modal.Header>
            <Modal.Body>
                <form className='row' onSubmit={submit}>
                    <div className='col-md-4'>
                        <div className='form-group' style={{position: "relative"}}>
                            <label>VIN</label>
                            <input type='text' onClick={() => setShowVinList(true)} placeholder={t("containers.enterVin")} className='form-control' value={formData.vin} onChange={(e) => setFormData((prev) => ({...prev, vin: e.target.value}))}/>
                            {showVinList && <OutsideClickHandler onOutsideClick={() => setShowVinList(false)}>
                                    <div className='booking-vin-code-suggestions'>
                                        <div className='suggestions-filter' style={{marginBottom: "10px"}}>
                                            <input placeholder={t("containers.typeToFilter")} type='text' className='form-control' onChange={(e) => {
                                                const data = vinList.filter((vincode) => vincode.vin.toLowerCarse().includes(e.target.value.toLowerCarse()))
                                                setFilteredVinList(data);
                                            }} />
                                        </div>
                                        {
                                            filteredVinList.map((car, i) => <div key={i} onClick={() => {
                                                setFormData((prev) => (
                                                    {...prev, vin: car.vin, purchase_date: core.formdatDate(new Date(car.purchase_date), 'yyyy-mm-dd'), model: car.model, 
                                                        manufacturer: car.mark, manufacturer_year: car.year, booking: car.booking, buyer_name: car.buyer, delivery_location: car.destination_port,
                                                        line: car.line, personal_number: car.receiver_identity_number, lot_number: car.lot_number, loading_port: car.us_port, user_id: car.dealer_id
                                                    }))
                                                setShowVinList(false);
                                            }}>{car.vin}</div>)
                                        }
                                        {
                                            filteredVinList.length == 0 && <div style={{textAlign: "center", width: "100%"}}>{t("containers.carsNotFound")}</div>
                                        }
                                    </div>
                                </OutsideClickHandler>}
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group mb-4'>
                            <label>{t("containers.containerNumber")}:</label>
                            <input name="container_number" className='form-control' type='text' required placeholder={t("containers.enterContainerNumber")} value={formData.container_number} onChange={(e) => setFormData((prev) => ({...prev, container_number: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <label>{t("containers.line")}</label>
                            <select type='text' placeholder='Enter receiver' className='form-control' value={formData.line} onChange={(e) => setFormData((prev) => ({...prev, line: e.target.value}))}>
                                <option>{t("containers.selectLine")}</option>
                                <option value={"Evergreen"}>Evergreen</option>
                                <option value={"Maersk"}>Maersk</option>
                                <option value={"MSC"}>MSC</option>
                                <option value={"Hapag-Lloyd"}>Hapag-Lloyd</option>
                                <option value={"CMA CGM"}>CMA CGM</option>
                                <option value={"ONE"}>ONE</option>
                                <option value={"COSCO"}>COSCO</option>
                                <option value={"ZIM"}>ZIM</option>
                                <option value={"TURKON"}>TURKON</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <label>{t("containers.boat")}</label>
                            <select className='form-control' value={formData.boat_id} onChange={(e) => {
                                setFormData((prev) => ({...prev, boat_id: e.target.value, boat_name: e.target.options[e.target.selectedIndex].text}))
                            }}>
                                <option>{t("containers.selectBoat")}</option>
                                {
                                    boats.map((boat) => <option key={boat.identification_code} value={boat.identification_code}>{boat.name}</option>)
                                }
                            </select>
                        </div>
                    </div>   
                    <div className='col-md-4'>
                        <div className='form-group mb-4'>
                            <label>{t("containers.purchaseDate")}:</label>
                            <input name="name" className='form-control' type='date' value={formData.purchase_date} onChange={(e) => setFormData((prev) => ({...prev, purchase_date: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group mb-4'>
                            <label>{t("containers.manufacturer")}:</label>
                            <input name="name" className='form-control' type='text' value={formData.manufacturer} onChange={(e) => setFormData((prev) => ({...prev, manufacturer: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group mb-4'>
                            <label>{t("containers.model")}:</label>
                            <input name="name" className='form-control' type='text' value={formData.model} onChange={(e) => setFormData((prev) => ({...prev, model: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group mb-4'>
                            <label>{t("containers.manufacturerYear")}:</label>
                            <input name="name" className='form-control' type='text' value={formData.manufacturer_year} onChange={(e) => setFormData((prev) => ({...prev, manufacturer_year: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group mb-4'>
                            <label>{t("containers.buyer")}:</label>
                            <input name="name" className='form-control' type='text' value={formData.buyer_name} onChange={(e) => setFormData((prev) => ({...prev, buyer_name: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group mb-4'>
                            <label>{t("containers.booking")}:</label>
                            <input name="name" className='form-control' type='text' value={formData.booking} onChange={(e) => setFormData((prev) => ({...prev, booking: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group mb-4'>
                            <label>{t("containers.deliveryLocation")}:</label>
                            <input name="name" className='form-control' type='text' value={formData.delivery_location} onChange={(e) => setFormData((prev) => ({...prev, delivery_location: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group mb-4'>
                            <label>{t("containers.personalNumber")}:</label>
                            <input name="name" className='form-control' type='text' value={formData.personal_number} onChange={(e) => setFormData((prev) => ({...prev, personal_number: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group mb-4'>
                            <label>{t("containers.lotNumber")}:</label>
                            <input name="name" className='form-control' type='text' value={formData.lot_number} onChange={(e) => setFormData((prev) => ({...prev, lot_number: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='form-group mb-4'>
                            <label>{t("containers.loadingPort")}:</label>
                            <input name="name" className='form-control' type='text' value={formData.loading_port} onChange={(e) => setFormData((prev) => ({...prev, loading_port: e.target.value}))}/>
                        </div>
                    </div>                 
                    <Modal.Footer>
                        <Button type='submit' variant={loading ? 'secondary' : 'primary'} disabled={loading}>{loading ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : type === "add" ? t("common.addNew") : t("common.save")}</Button>
                        <Button type='button' onClick={() => setShow(false)} variant='danger'>{t("common.close")}</Button>
                    </Modal.Footer>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default CreateContainer;